import { render, staticRenderFns } from "./TPATemplate.vue?vue&type=template&id=4844ac74&"
import script from "./TPATemplate.vue?vue&type=script&lang=js&"
export * from "./TPATemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports